export const VISAS = [
  {
    slug: "e-2-visum",
    badge: "Unternehmervisum",
    title: "E-2 Visum USA: Voraussetzungen, Kosten & Ablauf für Unternehmer",
    description:
      "E-2 Visum für Deutsche & Schweizer: Voraussetzungen, Kosten, Mindestinvestition und Ablauf – und warum 100.000 USD kein Muss sind. Persönlich begleitet auf Deutsch.",
    keywords:
      "E-2 Visum, E-2 Visum USA Voraussetzungen, E-2 Visum Kosten, E-2 Visum Mindestinvestition, Unternehmervisum USA, E-2 Visum Deutschland, E-2 Visum Schweiz, Unternehmer auswandern Florida",
    lead: "Das E-2 Visum ist der bewährteste Weg für Unternehmerinnen und Unternehmer aus Deutschland und der Schweiz, die in Florida gründen, investieren und leben möchten.",
    faqTitle: "Häufige Fragen zum E-2 Visum",
    blocks: [
      {
        heading: "Was ist das E-2 Visum?",
        paragraphs: [
          "Das E-2 Visum ist ein sogenanntes Treaty-Investor-Visum für die USA. Deutschland und die Schweiz gehören zu den Vertragsstaaten – Staatsangehörige beider Länder können es beantragen. Es erlaubt Ihnen, in den USA zu leben und ein Unternehmen zu führen, in das Sie substanziell investiert haben.",
          "Anders als viele andere Visa ist das E-2 unbegrenzt verlängerbar, solange Ihr Unternehmen läuft. Deshalb ist es der Klassiker für Auswanderer, die in Florida ein eigenes Geschäft aufbauen oder übernehmen wollen.",
        ],
      },
      {
        heading: "E-2 Visum Voraussetzungen",
        list: [
          "Staatsangehörigkeit eines Vertragsstaates (Deutschland und die Schweiz erfüllen dies)",
          "Eine substanzielle Investition in ein US-Unternehmen – bemessen am jeweiligen Geschäft, ohne fixen Mindestbetrag",
          "Das Unternehmen ist real und aktiv – kein passives Investment, keine Briefkastenfirma",
          "Sie kontrollieren das Unternehmen (mindestens 50 % oder operative Kontrolle)",
          "Das Unternehmen ist nicht marginal: Es muss mehr erwirtschaften als nur Ihren Lebensunterhalt",
          "Sie führen das Unternehmen aktiv und belegen die Herkunft Ihrer Investitionsmittel",
        ],
      },
      {
        heading: "E-2 Visum Kosten & Mindestinvestition",
        sub: [
          {
            heading: "Brauche ich wirklich 100.000 USD?",
            paragraphs: [
              "Nein – das ist ein hartnäckiger Mythos. Das Gesetz kennt keinen fixen Mindestbetrag für das E-2 Visum. Entscheidend ist, dass Ihre Investition im Verhältnis zum Geschäft substanziell ist und real in den Betrieb fliesst. Je nach Geschäftsmodell sind auch deutlich kleinere Summen möglich – was zählt, ist ein glaubwürdiger, tragfähiger Plan.",
              "Wichtig ist ausserdem: Das Geld muss tatsächlich investiert und dem Geschäftsrisiko ausgesetzt sein. Ein Betrag auf dem Konto allein genügt nicht.",
            ],
          },
          {
            heading: "Womit Sie bei den Kosten rechnen müssen",
            paragraphs: [
              "Zu den staatlichen Antragsgebühren kommen je nach Fall Kosten für Gründung, Businessplan und die rechtliche Antragstellung. Was in Ihrer Situation konkret anfällt, besprechen wir transparent im kostenlosen Erstgespräch – bevor irgendetwas entsteht.",
            ],
          },
        ],
      },
      {
        heading: "E-2 Visum beantragen: Der Ablauf in 5 Schritten",
        list: [
          "Strategie und Geschäftskonzept festlegen – bei Bedarf mit unseren fixfertigen Business-Ideen für Florida",
          "US-Unternehmen gründen (z. B. eine LLC in Florida) und die Investition tatsächlich leisten",
          "Antragsunterlagen zusammenstellen: Businessplan, Investitionsnachweise, Unternehmensdokumente",
          "Antrag beim zuständigen US-Konsulat einreichen – für Deutschland typischerweise Frankfurt, für die Schweiz Bern",
          "Visum-Interview und Entscheidung",
        ],
      },
      {
        heading: "E-2 Visum Dauer & Verlängerung",
        paragraphs: [
          "Das E-2 Visum wird je nach Staatsangehörigkeit für mehrere Jahre erteilt und kann unbegrenzt verlängert werden, solange Ihr Unternehmen die Voraussetzungen erfüllt. Viele Unternehmer leben so über Jahrzehnte in den USA.",
        ],
      },
      {
        heading: "E-2 Visum für Ehepartner & Familie",
        paragraphs: [
          "Ihre Ehepartnerin oder Ihr Ehepartner erhält ein eigenes Visum und darf in den USA uneingeschränkt arbeiten – auch bei anderen Arbeitgebern. Kinder bis 21 Jahre reisen mit und können zur Schule gehen und studieren.",
        ],
      },
      {
        heading: "Welches Unternehmen eignet sich fürs E-2 Visum?",
        paragraphs: [
          "Geeignet sind reale, operierende Geschäfte – von Dienstleistung und Handel über Gastronomie bis zur Immobilienverwaltung. Nicht geeignet sind reine Geldanlagen. Sie wollen gründen, wissen aber noch nicht womit? Genau dafür haben wir unsere fixfertigen Business-Ideen entwickelt: erprobte Konzepte für den US-Markt, abgestimmt auf Ihre Visumsstrategie.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Das E-2 Visum setzt voraus, dass Sie Ihr Unternehmen aktiv führen – es ist kein Visum für passive Investments. Ausserdem ist es befristet: Es führt nicht automatisch zur Green Card. Wer dauerhaft bleiben will, sollte früh Wege wie EB-2 NIW oder EB-1C prüfen.",
    },
    faq: [
      {
        q: "Kann ich mit dem E-2 Visum eine Green Card bekommen?",
        a: "Nicht direkt – das E-2 Visum ist befristet, wenn auch unbegrenzt verlängerbar. Wer dauerhaft in den USA bleiben möchte, prüft parallel direkte Green-Card-Wege wie EB-2 NIW oder EB-1C. Genau dabei helfen wir Ihnen im kostenlosen Erstgespräch.",
      },
      {
        q: "Wie lange dauert die Beantragung des E-2 Visums?",
        a: "Das hängt von Ihrer Vorbereitung und dem zuständigen Konsulat ab. Den grössten Teil der Zeit nimmt die saubere Vorbereitung in Anspruch: Unternehmensgründung, Investition und überzeugende Unterlagen. Mit guter Vorbereitung ist der restliche Weg überschaubar.",
      },
      {
        q: "Muss ich das Unternehmen selbst führen?",
        a: "Ja. Das E-2 Visum setzt voraus, dass Sie das Unternehmen aktiv leiten und kontrollieren – es ist kein Visum für passive Geldanlagen.",
      },
    ],
    closing:
      "Wir prüfen Ihre Ausgangslage, stimmen Ihr Geschäftskonzept auf das Visum ab und begleiten Ihre Antragstellung komplett – von der Gründung bis zum Interview.",
  },
  {
    slug: "eb-2-niw-greencard",
    badge: "Direkt zur Green Card",
    title: "EB-2 NIW: Die Green Card ohne Arbeitgeber",
    description:
      "EB-2 National Interest Waiver: Voraussetzungen, Ablauf und Chancen für Fachkräfte und Unternehmer aus Deutschland und der Schweiz – der direkte Weg zur Green Card ohne US-Arbeitgeber.",
    keywords:
      "EB-2 NIW, EB-2 NIW Green Card, National Interest Waiver, Green Card ohne Arbeitgeber, Green Card USA Unternehmer, EB-2 NIW Voraussetzungen, Green Card selbst beantragen, EB-2 NIW Deutschland Schweiz",
    lead: "Der EB-2 National Interest Waiver (NIW) ist einer der spannendsten Wege in die USA: Er führt direkt zur Green Card – und Sie brauchen dafür keinen US-Arbeitgeber.",
    faqTitle: "Häufige Fragen zum EB-2 NIW",
    blocks: [
      {
        heading: "Was ist der EB-2 National Interest Waiver?",
        paragraphs: [
          "EB-2 ist eine Green-Card-Kategorie für Personen mit höherem Hochschulabschluss oder aussergewöhnlichen Fähigkeiten. Normalerweise braucht EB-2 ein Jobangebot und eine aufwendige Arbeitsmarktprüfung (PERM). Der National Interest Waiver erlässt beides, wenn Ihr Vorhaben im nationalen Interesse der USA liegt.",
          "Das bedeutet: Sie können die Petition selbst stellen – als sogenannte Self-Petition, unabhängig von einem Arbeitgeber, und erhalten bei Bewilligung direkt die unbefristete Green Card.",
        ],
      },
      {
        heading: "EB-2 NIW Voraussetzungen",
        sub: [
          {
            heading: "Höherer Abschluss oder aussergewöhnliche Fähigkeiten",
            paragraphs: [
              "Sie qualifizieren sich für EB-2 grundsätzlich über einen Master-Abschluss (oder Bachelor plus mindestens fünf Jahre fortschreitende Berufserfahrung) oder über aussergewöhnliche Fähigkeiten in Wirtschaft, Wissenschaft oder Kunst – nachgewiesen etwa durch Erfolge, Auszeichnungen oder überdurchschnittliche Ergebnisse.",
            ],
          },
          {
            heading: "Die drei Prüfpunkte des National Interest Waiver",
            list: [
              "Ihr Vorhaben hat substanziellen Wert und nationale Bedeutung für die USA",
              "Sie sind gut positioniert, es voranzubringen – durch Erfahrung, Erfolge und einen belastbaren Plan",
              "Es ist für die USA vorteilhaft, auf Jobangebot und Arbeitsmarktprüfung zu verzichten",
            ],
          },
        ],
      },
      {
        heading: "EB-2 NIW für Unternehmer",
        paragraphs: [
          "Auch Unternehmerinnen und Unternehmer können den NIW nutzen – etwa mit einem Geschäftsvorhaben, das Arbeitsplätze schafft, Innovation bringt oder einen realen Bedarf in den USA deckt. Entscheidend sind eine belegbare Erfolgsbilanz und ein überzeugender, gut dokumentierter Plan. Genau hier liegt unsere Stärke: Wir strukturieren Ihr Vorhaben so, dass es den Prüfpunkten standhält.",
        ],
      },
      {
        heading: "EB-2 NIW beantragen: Der Ablauf",
        list: [
          "Chancenprüfung und Strategie im kostenlosen Erstgespräch",
          "Nachweise und Argumentation strukturiert zusammenstellen",
          "Petition (Formular I-140) vorbereiten und einreichen – wir begleiten jeden Schritt",
          "Nach Bewilligung: Konsularverfahren in Frankfurt oder Bern – oder Statusanpassung in den USA",
          "Green Card für Sie – Ehepartner und unverheiratete Kinder unter 21 sind inklusive",
        ],
      },
      {
        heading: "E-2 Visum oder EB-2 NIW – was passt zu Ihnen?",
        paragraphs: [
          "Das E-2 Visum ist befristet (wenn auch unbegrenzt verlängerbar) und an Ihr Unternehmen gebunden. EB-2 NIW führt direkt zur unbefristeten Green Card und macht Sie unabhängig. Manche Kunden starten mit E-2 und reichen den NIW parallel ein. Welcher Weg realistisch ist, hängt von Ihrem Profil ab – genau das prüfen wir ehrlich für Sie.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Der NIW ist keine Selbstverständlichkeit: Die Petition lebt von starken Nachweisen und einer sauberen Argumentation. Wir schärfen und strukturieren Ihren Fall komplett, bevor die Petition eingereicht wird – das erhöht Ihre Chancen spürbar.",
    },
    faq: [
      {
        q: "Brauche ich für EB-2 NIW einen Arbeitgeber in den USA?",
        a: "Nein. Beim National Interest Waiver reichen Sie die Petition selbst ein (Self-Petition) – ein US-Arbeitgeber oder ein Jobangebot sind nicht nötig.",
      },
      {
        q: "Wie lange dauert ein EB-2-NIW-Antrag?",
        a: "Das hängt von der Bearbeitungszeit der Behörden und der Qualität Ihrer Unterlagen ab. Die aufwendigste Phase ist die Vorbereitung der Petition – je stärker Ihre Nachweise von Anfang an sind, desto reibungsloser läuft das Verfahren.",
      },
      {
        q: "Bekommt meine Familie ebenfalls eine Green Card?",
        a: "Ja. Bei einer bewilligten EB-2-NIW-Petition erhalten auch Ihre Ehepartnerin oder Ihr Ehepartner und Ihre unverheirateten Kinder unter 21 die Green Card.",
      },
    ],
    closing:
      "Wir prüfen ehrlich, ob EB-2 NIW für Sie infrage kommt, und koordinieren Ihr Verfahren von der Strategie bis zur Einreichung – persönlich und auf Deutsch.",
  },
  {
    slug: "eb-1c-greencard",
    badge: "Direkt zur Green Card",
    title: "EB-1C: Green Card für Manager, Führungskräfte & Unternehmer",
    description:
      "EB-1C Voraussetzungen und Ablauf: Green Card durch Überstellung in Ihre US-Niederlassung – für Inhaber und Führungskräfte aus Deutschland und der Schweiz.",
    keywords:
      "EB-1C, EB-1C Green Card, EB-1C Voraussetzungen, Green Card Manager, Green Card Unternehmer USA, Multinational Manager Green Card, Green Card Firmenübertragung USA",
    lead: "Sie führen bereits ein Unternehmen in Deutschland oder der Schweiz? Dann kann EB-1C Ihr direkter Weg zur Green Card sein – über die Überstellung als Managerin, Manager oder Führungskraft in Ihre US-Einheit.",
    faqTitle: "Häufige Fragen zu EB-1C",
    blocks: [
      {
        heading: "Was ist EB-1C?",
        paragraphs: [
          "EB-1C ist eine Green-Card-Kategorie für Manager und Führungskräfte multinationaler Unternehmen. Voraussetzung ist eine qualifizierte Verbindung zwischen Ihrer bestehenden Firma und einer US-Einheit – etwa eine Tochtergesellschaft, Niederlassung oder Schwesterfirma in Florida. Bei Bewilligung erhalten Sie direkt die unbefristete Green Card.",
        ],
      },
      {
        heading: "EB-1C Voraussetzungen",
        sub: [
          {
            heading: "Anforderungen an Sie",
            list: [
              "Mindestens ein Jahr Führungstätigkeit bei der ausländischen Firma innerhalb der letzten drei Jahre",
              "Ihre Position in den USA liegt auf Führungs- oder Managementebene",
            ],
          },
          {
            heading: "Anforderungen an die Unternehmen",
            list: [
              "Qualifizierende Beziehung zwischen Heimatfirma und US-Einheit (Tochter, Niederlassung, Schwester)",
              "Die US-Einheit ist seit mindestens einem Jahr aktiv und operativ",
              "Beide Unternehmen arbeiten real – mit nachvollziehbaren Strukturen und Führungsrollen",
            ],
          },
        ],
      },
      {
        heading: "Der Weg über L-1A zu EB-1C",
        paragraphs: [
          "Ihre US-Einheit ist noch neu? Dann führt der Weg typischerweise zuerst über das L-1A-Visum: Es erlaubt die Überstellung von Führungskräften in eine neue US-Niederlassung. Nach etwa einem Jahr aktivem US-Geschäftsbetrieb kann der EB-1C-Antrag gestellt werden – und daraus wird die Green Card.",
          "Wir bauen diesen Weg mit Ihnen von Anfang an richtig auf: US-Gründung in Florida, saubere Unternehmensstruktur, überzeugende Führungsrollen auf beiden Seiten.",
        ],
      },
      {
        heading: "EB-1C beantragen: Der Ablauf",
        list: [
          "Analyse Ihrer Unternehmenssituation und Chancenprüfung im Erstgespräch",
          "Aufbau oder Prüfung der US-Struktur (z. B. LLC in Florida als Tochtergesellschaft)",
          "Bei neuer US-Einheit: Überstellung über L-1A und Aufbau des US-Betriebs",
          "EB-1C-Petition vorbereiten und einreichen – komplett von uns begleitet",
          "Green Card für Sie – Ehepartner und Kinder unter 21 inklusive",
        ],
      },
      {
        heading: "Vorteile der EB-1C Green Card",
        list: [
          "Keine Arbeitsmarktprüfung (kein PERM) nötig",
          "Direkter Weg zur unbefristeten Green Card",
          "Familie reist mit – der Partner darf arbeiten, Kinder gehen zur Schule",
          "Ideal für Inhaberinnen und Inhaber bestehender Firmen, die in die USA expandieren",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "EB-1C verlangt eine saubere Unternehmensstruktur und nachvollziehbare Führungsrollen auf beiden Seiten des Atlantiks. Wir bauen genau das mit Ihnen auf – von der US-Gründung über die Struktur bis zur fertigen Petition.",
    },
    faq: [
      {
        q: "Muss meine US-Firma für EB-1C schon bestehen?",
        a: "Für EB-1C muss die US-Einheit seit mindestens einem Jahr aktiv sein. Bei einer Neugründung führt der Weg deshalb typischerweise zuerst über das L-1A-Visum – danach folgt der EB-1C-Antrag.",
      },
      {
        q: "Geht EB-1C auch für kleinere Unternehmen?",
        a: "Entscheidend sind weniger die Unternehmensgrösse als saubere Strukturen und echte Führungsrollen auf beiden Seiten. Ob Ihre Konstellation trägt, prüfen wir ehrlich im kostenlosen Erstgespräch.",
      },
      {
        q: "Kann meine Familie mit in die USA?",
        a: "Ja. Ihre Ehepartnerin oder Ihr Ehepartner und Ihre unverheirateten Kinder unter 21 erhalten ebenfalls die Green Card; der Partner darf in den USA arbeiten, Kinder gehen zur Schule.",
      },
    ],
    closing:
      "Wir prüfen, ob EB-1C zu Ihrer Unternehmenssituation passt, und begleiten den gesamten Aufbau – von der US-Gründung bis zur Green-Card-Einreichung.",
  },
  {
    slug: "l-1a-visum",
    badge: "Führungskräfte-Visum",
    title: "L-1A Visum: Als Führungskraft in die USA expandieren",
    description:
      "L-1A Visum für Manager und Unternehmer: Voraussetzungen, Ablauf und der Weg von der neuen US-Niederlassung in Florida bis zur Green Card über EB-1C – auf Deutsch begleitet.",
    keywords:
      "L-1A Visum, L-1A Visum USA Voraussetzungen, L-1 Visum, Manager Überstellung USA, L-1A Green Card Weg, Firmenüberstellung USA, US Niederlassung gründen Visum",
    lead: "Das L-1A Visum ist der bewährte Weg für Inhaber und Führungskräfte, die ihre bestehende Firma in Deutschland oder der Schweiz in die USA führen wollen – inklusive Neugründung einer US-Niederlassung.",
    faqTitle: "Häufige Fragen zum L-1A Visum",
    blocks: [
      {
        heading: "Was ist das L-1A Visum?",
        paragraphs: [
          "Das L-1A Visum ist ein Visum für die innerbetriebliche Überstellung von Managern und Führungskräften: Ihre bestehende Firma entsendet Sie in eine verbundene US-Einheit – etwa eine Tochtergesellschaft oder Niederlassung in Florida. Es funktioniert auch, wenn diese US-Einheit erst gegründet wird (sogenanntes New-Office-L-1A).",
          "Damit ist das L-1A ideal für Unternehmerinnen und Unternehmer, die ihr Geschäft über den Atlantik erweitern wollen – und es ist der klassische Vorbereiter für die Green Card über EB-1C.",
        ],
      },
      {
        heading: "L-1A Visum Voraussetzungen",
        sub: [
          {
            heading: "Anforderungen an Sie",
            list: [
              "Mindestens ein Jahr Führungstätigkeit bei Ihrer Firma im Ausland innerhalb der letzten drei Jahre",
              "In den USA übernehmen Sie eine echte Führungs- oder Managementposition",
            ],
          },
          {
            heading: "Anforderungen an die Unternehmen",
            list: [
              "Qualifizierende Verbindung zwischen Heimatfirma und US-Einheit (Tochter, Niederlassung, Schwester)",
              "Beide Unternehmen sind real und aktiv",
              "Bei einer neuen US-Niederlassung: geeignete Geschäftsräume und ein tragfähiger Geschäftsplan",
            ],
          },
        ],
      },
      {
        heading: "L-1A für eine neue US-Niederlassung (New Office)",
        paragraphs: [
          "Sie gründen die US-Einheit gerade erst? Dann wird das L-1A zunächst für ein Jahr erteilt – Zeit, um den Betrieb aufzubauen. Für die Verlängerung müssen Sie zeigen, dass die US-Einheit real arbeitet und Ihre Führungsrolle trägt. Wir bauen das mit Ihnen von Anfang an richtig auf: Gründung in Florida, Struktur, Personalplan und Geschäftsräume.",
        ],
      },
      {
        heading: "L-1A beantragen: Der Ablauf",
        list: [
          "Analyse Ihrer Situation und Strategie im kostenlosen Erstgespräch",
          "US-Struktur aufbauen (z. B. LLC in Florida als Tochtergesellschaft)",
          "Petition (Formular I-129) vorbereiten und einreichen – wir begleiten jeden Schritt",
          "Nach Bewilligung: Visumtermin am US-Konsulat und Einreise",
          "US-Betrieb aufbauen – mit Blick auf die spätere Verlängerung und EB-1C",
        ],
      },
      {
        heading: "L-1A Dauer & Familie",
        paragraphs: [
          "Bei einer neuen US-Niederlassung gilt das L-1A zunächst ein Jahr, danach sind Verlängerungen bis zu maximal sieben Jahre möglich. Ihre Ehepartnerin oder Ihr Ehepartner erhält ein L-2-Visum und darf in den USA arbeiten; Kinder bis 21 Jahre reisen mit und gehen zur Schule.",
        ],
      },
      {
        heading: "Von L-1A zur Green Card über EB-1C",
        paragraphs: [
          "Das L-1A ist befristet – aber es ist das perfekte Sprungbrett: Sobald Ihre US-Einheit etwa ein Jahr aktiv ist, kann der EB-1C-Antrag folgen, der direkt zur unbefristeten Green Card führt. Wir planen Ihre Struktur von Tag eins an so, dass dieser Übergang gelingt.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Beim L-1A wird Ihre Führungsrolle genau geprüft: Wer in den USA nur das Tagesgeschäft selbst erledigt, gilt nicht als Manager. Entscheidend sind Struktur, Personal und eine überzeugende Darstellung Ihrer Führungsaufgaben – genau dabei unterstützen wir Sie.",
    },
    faq: [
      {
        q: "Kann ich mit dem L-1A Visum eine neue Firma in den USA gründen?",
        a: "Ja. Das New-Office-L-1A ist genau dafür gedacht: Ihre bestehende Firma gründet eine US-Einheit, und Sie werden als Führungskraft überstellt. Wichtig sind geeignete Geschäftsräume und ein tragfähiger Geschäftsplan.",
      },
      {
        q: "Wie lange gilt das L-1A Visum?",
        a: "Bei einer neuen US-Niederlassung zunächst ein Jahr; bei bestehenden US-Einheiten bis zu drei Jahre. Verlängerungen sind bis zu maximal sieben Jahre möglich.",
      },
      {
        q: "Führt das L-1A Visum zur Green Card?",
        a: "Indirekt, ja: Nach etwa einem Jahr aktivem US-Geschäftsbetrieb kann der EB-1C-Antrag folgen – der direkte Weg zur unbefristeten Green Card für Sie und Ihre Familie.",
      },
    ],
    closing:
      "Wir prüfen Ihre Ausgangslage, bauen die US-Struktur mit Ihnen auf und begleiten Ihre Überstellung komplett – mit Blick auf die Green Card von Anfang an.",
  },
];

export function getVisa(slug) {
  return VISAS.find((v) => v.slug === slug);
}
